import { general } from './general';
import { collection } from './collection';
import { branch } from './branch';
import { name } from './name';
import { textarea } from './textarea';
import { datecontrol } from './datecontrol';
import { text } from './text';
import { notapplicable } from './notapplicable';

export const passport = (data = {}) => general('passport', {
  Expiration: datecontrol(data?.Expiration),
  Identification: text(data?.Identification),
  Issued: datecontrol(data?.Issued),
  Name: name(data?.Name),
  Number: text(data?.Number),
  PassportNumberNotApplicable: notapplicable(data?.PassportNumberNotApplicable),
  PassportNumberNotApplicableExplanation: textarea(data?.PassportNumberNotApplicableExplanation),
  Status: branch(data?.Status),
  StatusCommentText: textarea(data?.StatusCommentText),
  Has: branch(data?.Has),
});

export const passports = (data = {}) => collection(((data || {}).items || []).map((x) => {
  const xitem = x.Item || {};
  return {
    Item: passport(xitem).props,
  };
}), data?.branch);
